import Icon, { type IconName } from "@/components/Icon";
import Image from "next/image";

export type ItemIconProps = {
	icon?: IconName;
	iconUrl?: string;
	alt?: string;
	isImage?: boolean;
	width?: number;
	height?: number;
	className?: string;
};

const ItemIcon = ({
	icon,
	iconUrl,
	alt,
	isImage,
	width,
	height,
	className,
}: ItemIconProps) => {
	if (isImage && iconUrl) {
		return (
			<Image
				src={iconUrl}
				alt={alt ?? ""}
				className={className}
				width={width ?? 64}
				height={height ?? 64}
			/>
		);
	}

	if (icon) {
		return (
			<div className={className}>
				<Icon name={icon} aria-hidden="true" />
			</div>
		);
	}

	return null;
};

export default ItemIcon;
